export default "__VITE_ASSET__B5Q2selZ__"